export enum EdwardColors {
  DARK = 'rgba(255, 203, 19, 1)',
  DARKER = 'rgba(255, 212, 78, 1)',
  MEDIUM = 'rgba(255, 221, 127, 1)',
  LIGHTER = 'rgba(255, 232, 167, 1)',
  LIGHT = 'rgba(255, 243, 210, 1)',

  SECONDARY = 'rgba(186, 130, 53, 1)',

  BLUE = 'rgba(47, 160, 209, 1)',

  GREEN = 'rgba(82, 199, 0, 1)',
  GREEN_MEDIUM = 'rgba(131,213,74,1)',
  GREEN_LIGHTER = 'rgba(144, 237, 125, 1)',
  GREEN_LIGHT = 'rgba(188,252,204,1)',

  NEGATIVE = '#000',
  POSITIVE = 'rgba(82, 199, 0, 1)',
  WARNING = '#ff6600',
  ALERT = '#ff0000',

  GRAY_DARKER = 'rgba(88, 88, 88, 1)', // #585858
  GRAY_MEDIUM = 'rgba(130, 130, 130, 1)', // #828282
  GRAY_LIGHTER = 'rgba(189, 189, 189, 1)', // #bdbdbd
  GRAY_LIGHT = 'rgba(210, 210, 210, 1)', // #d2d2d2
  GRAY_LIGHTEST = 'rgba(240, 240, 240, 1)', // #eeeeee
  GRAY_EXTRALIGHT = 'rgba(245, 245, 245, 1)', // #f5f5f5

  GOLD = '#c1a53a'
}

interface Colors {
  [key: string]: string;
}

const colors: Colors = {
  // Chart/table colors:
  IK1: '#cd81ff', // Akcie
  IK2: '#00e2c8', // Alt. inv.
  IK3: '#18d4fc', // Dluhopisy
  IK4: '#69a5ff', // Hotovost
  IK5: '#aaaaaa',

  // Portfolio composition
  ASSET_UNKNOWN: '#eeeeee',
  ASSET_STOCK: '#cd81ff',
  ASSET_ALTERNATIVE: '#00e2c8',
  ASSET_BOND: '#18d4fc',
  ASSET_CASH: '#69a5ff',
  ASSET_REAL_ESTATE: '#736fdb',
  ASSET_COMMODITY: '#e06ac5',
  ASSET_CRYPTO: '#06a693',

  CURRENCY_UNKNOWN: '#eeeeee',
  CURRENCY_CZK: '#004643',
  CURRENCY_EUR: '#9eb25d',
  CURRENCY_USD: '#d3dc6d',
  CURRENCY_CHF: '#5f7026',
  CURRENCY_JPY: '#bab365',
  CURRENCY_OTHER: '#818A64',

  REGION_UNKNOWN: '#eeeeee',
  REGION_CENTRAL_EUROPE: '#8f2d56',
  REGION_EUROPE: '#e9724c',
  REGION_NORTH_AMERICA: '#c5283d',
  REGION_ASIA: '#481d24',
  REGION_EMERGING: '#a35652',
  REGION_OTHER: '#58355e',

  // Ext. products (property)
  PROPERTY_TYPE_REAL_ESTATE: '#939291',
  PROPERTY_TYPE_REAL_ESTATE_RENT: '#7d7d7d',
  PROPERTY_TYPE_COMPANY: '#d0b035',
  PROPERTY_TYPE_VALUABLES: '#dcb830',
  PROPERTY_TYPE_OTHER_PROPERTY: '#e9c023',

  // IncomeOverview:
  INCOME_EMPLOYMENT: EdwardColors.GRAY_LIGHT,
  INCOME_BUSINESS: EdwardColors.GRAY_LIGHTER,
  INCOME_PARTNER_EMPLOYMENT: '#a8a8a8',
  INCOME_PARTNER_BUSINESS: '#9a9a9a',
  INCOME_EXTRA: '#e9e9e9',
  INCOME_EXTRA_RETIREMENT: '#dfdfdf',

  // Darker colors/shade:

  '#000000': '#ffcb13', // Edward (special)

  '#eeeeee': '#dddddd',

  '#cd81ff': '#c173f5',
  '#00e2c8': '#01d6bb',
  '#18d4fc': '#03c5ec',
  '#69a5ff': '#5297f4',
  '#aaaaaa': '#999999',
  '#736fdb': '#3430bc',
  '#e06ac5': '#c52c98',
  '#06a693': '#05857a',

  '#004643': '#002224',
  '#9eb25d': '#627c22',
  '#d3dc6d': '#afbe2f',
  '#5f7026': '#47561d',
  '#bab365': '#9b9854',
  '#818A64': '#636b4e',

  '#8f2d56': '#50081d',
  '#e9724c': '#d53317',
  '#c5283d': '#98060f',
  '#481d24': '#140305',
  '#a35652': '#a33d37',
  '#58355e': '#3c1742',
};

export default colors;

